import "./App.css";
import "./themes.css";
import './grey.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Leaderboard from "./pages/Leaderboard";
import Rewards from "./pages/Rewards";
import VipRewards from "./pages/VipRewards";
import Keno from "./pages/Keno";
import Blackjack from "./pages/Blackjack";
import Originals from "./pages/Originals";
import OriginalGame from "./pages/OriginalGame";
import Admin from "./pages/Admin";
import Account from "./pages/Account";
import AccountBets from './pages/AccountBets';
import Settings from './pages/Settings';
import DiscordCallback from './pages/DiscordCallback';
import KickCallback from './pages/KickCallback';
import Privacy from './pages/Privacy';
import { AccountLayout } from './components/account/AccountLayout';
import { NotificationProvider } from './components/notifications/NotificationProvider';
import { Toaster } from "./components/ui/toaster";
import { Toaster as TipToaster } from 'sonner';
import RouteTransition from "./components/RouteTransition";
import { ThemeProvider } from "./theme";
import { AuthProvider } from "./auth";
import { GameSessionProvider } from "./components/keno/GameSession";
import { CurrencyProvider } from './components/keno/CurrencyContext';
import { LiveStatsDockProvider } from './components/keno/LiveStatsDockContext';
import Connections from './pages/Connections';
import { SiteAvailability } from './components/site/SiteAvailability';
import SharedBet from './pages/SharedBet';
import { ChatMentionsProvider } from './components/chat/ChatMentionsProvider';
import { SiteAccessGate } from './components/site/SiteAccessGate';
import { TrafficTracker } from './components/site/TrafficTracker';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CurrencyProvider><GameSessionProvider>
        <div className="App">
          <div className="page-bg" data-testid="page-background" aria-hidden="true" />
          <div className="page-grid" data-testid="page-background-grid" aria-hidden="true" />
          <BrowserRouter>
            <LiveStatsDockProvider>
            <SiteAccessGate>
            <TrafficTracker />
            <SiteAvailability>
            <NotificationProvider>
            <ChatMentionsProvider>
            <RouteTransition />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/rewards" element={<Rewards />} />
              <Route path="/vip-rewards" element={<VipRewards />} />
              <Route path="/originals" element={<Originals />} />
              <Route path="/games/:gameId" element={<OriginalGame />} />
              <Route path="/games/keno" element={<Keno />} />
              <Route path="/games/blackjack" element={<Blackjack />} />
              <Route element={<AccountLayout />}>
                <Route path="/account" element={<Account />} />
                <Route path="/account/bets" element={<AccountBets />} />
                <Route path="/account/connections" element={<Connections />} />
                <Route path="/account/kick-rewards" element={<Navigate to="/account" replace />} />
                <Route path="/settings" element={<Settings />} />
                  <Route path="/account/privacy" element={<Privacy />} />
              </Route>
              <Route path="/admin" element={<Admin />} />
              <Route path="/auth/discord" element={<DiscordCallback />} />
              <Route path="/auth/kick" element={<KickCallback />} />
              <Route path="/bet/:publicId" element={<SharedBet />} />
            </Routes>
            </ChatMentionsProvider>
            </NotificationProvider>
            </SiteAvailability>
            </SiteAccessGate>
            </LiveStatsDockProvider>
          </BrowserRouter>
          <Toaster />
          <TipToaster theme="dark" position="top-left" offset={{ top: 84, left: 24, right: 24 }} mobileOffset={{ top: 128, left: 16, right: 16 }} />
        </div>
        </GameSessionProvider></CurrencyProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
